export default "__VITE_ASSET__C973mO0B__"